import React from 'react';
import Button from 'react-bootstrap/Button';
import './styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

interface Props {
  currentPage: number;
  perPage?: number;
  total?: number;
  totalPages?: number;
  onPreviousClick: (number) => void;
  onNextClick: (number) => void;
}

const DEFAULT_PER_PAGE = 10;

const Paginator: React.FC<Props> = ({
  currentPage,
  perPage = DEFAULT_PER_PAGE,
  total,
  totalPages,
  onNextClick,
  onPreviousClick
}) => {
  let pages = 1;
  if (totalPages) {
    pages = totalPages;
  } else {
    if (total < 1 || total === undefined) {
      pages = 1;
    } else {
      pages = Math.ceil(total / perPage);
    }
  }
  return (
    <div className="paginator">
      Page {currentPage} of {pages}{' '}
      <Button disabled={currentPage === 1} onClick={() => onPreviousClick(currentPage - 1)}>
        <FontAwesomeIcon icon={faAngleLeft} />
      </Button>{' '}
      <Button disabled={currentPage === pages} onClick={() => onNextClick(currentPage + 1)}>
        <FontAwesomeIcon icon={faAngleRight} />
      </Button>
    </div>
  );
};

export default Paginator;
